export const ODOO_ERROR_MESSAGE = {
    'duplicate key value violates unique constraint "res_users_login_key"\nDETAIL:  Key (login)=(': 'The user with this email already exists',
}
